import React, { useEffect, useState, useContext } from 'react'

import { Link, useHistory, useLocation } from "react-router-dom"
import Modal from "react-bootstrap/Modal";
import { dashboard, DashboardUnselected, HMUnSelected, HMSelected, MonitoringHubLogo, AlertPrePostSelected, AlertPrePostDefault, PanelControl, PanelControlWhite, CentralizeRecording, CentralizeRecordingSelected, QualityControl, QualityControlWhite, ExternalLinkWhite, ExternalLink } from '../../assets/images'
import alertUnselected from '../../assets/images/sidebar-logo/alertUnselected.svg'
import alertSelected from '../../assets/images/sidebar-logo/alertSelected.svg'
import cameraSelected from '../../assets/images/sidebar-logo/camera-selected.svg'
import cameraUnselected from '../../assets/images/sidebar-logo/camera-unselected.svg'
import reportSelected from '../../assets/images/sidebar-logo/reports-selected.svg'
import reportUnselected from '../../assets/images/sidebar-logo/reports-unselected.svg'
import configSelected from '../../assets/images/sidebar-logo/config-selected.svg'
import configSelectedWhite from '../../assets/images/sidebar-logo/config-selected-white.svg'

import { DrawerContext } from "../../Context/DrawerContext";
import { ConversationStateContext } from '../../Context/ConversationStateContext'
import { CheckForPrivilege } from '../../pages/Profile/PrivilegeExtension'
import { CLIENT_COMPONENET_LINK, CLOUD_STREAMING, VERSION, IS_DASHBOARD_TAB_HIDDEN, IS_ALERTS_TAB_HIDDEN, IS_CAMERAS_TAB_HIDDEN, IS_HEALTH_MONITORING_TAB_HIDDEN, IS_REPORTS_TAB_HIDDEN, IS_PANELCONTROL_TAB_HIDDEN, IS_CUSTOM_REPORTS_TAB_HIDDEN, IS_DAILY_REPORTS_TAB_HIDDEN, IS_PANEL_UP_DOWN_REPORTS_TAB_HIDDEN, IS_ATM_REPORTS_TAB_HIDDEN, IS_DASHBOARD_CHART_TAB_HIDDEN, IS_ANAND_REPORT_TAB_HIDDEN, EXTERNAL_LINK } from '../../config'
import { GetDynamicSidebarMenu, MenuMasterListAPI } from '../../services/dashboardService';
import { ABOUTTERMS, ALLALERTS, ATMSITEREPORT, AVAILABLERECORDINGREPORT, CAMERA_SINGLE_PLAYBACK, CAMERAS, CCTVACTIVITY, CONFIGURATION, CUSTOMERACTIVITY, CUSTOMERSITEACTIVITY, DAILYHEALTHCHECKREPORT, DASHBOARD, DASHBOARDCHARTS, EVENTACTIVITYREPORT, HEALTHMONITORING, HOMEPAGE, MYALERTS, OPERATORALERTREPORT, PANELACTIVITY, PANELCONTROL, PANELUPDOWNREPORT, REPORTS, ROOT, SAMPLEREPORT ,ANANDREPORT, CENTRALIZERECORDING, QUALITYCONTROL, DASHBOARDCONFIG, REPORTS_ONE, DeviceInstallationReport, DeviceStageReport, REPORT_INDEX,DASHBOARD1,DASHBOARD2, REPORT_VIEW} from '../../navigation/CONSTANTS';
import { ThemeContext } from '../../Context/ThemeContext';
import { AlertsModule } from '../../utils/ModuleConstants';


export default function Sidebar({
    selectedTab,
    setSelectedTab,
    selectedSubMenu,
    setSelectedSubMenu,
    isSuperUser
}) {

    let getMenusAccess = JSON.parse(localStorage.getItem('user'));
    let menusAccess = getMenusAccess?.MenuList;
    let IS_DASHBOARD_TAB_HIDDEN = true
    let IS_ALERTS_TAB_HIDDEN = true
    let IS_CAMERAS_TAB_HIDDEN = true
    let IS_HEALTH_MONITORING_TAB_HIDDEN = true
    let IS_PANELCONTROL_TAB_HIDDEN = true
    let IS_REPORTS_TAB_HIDDEN = true
    let IS_CUSTOM_REPORTS_TAB_HIDDEN = true
    let IS_CONFIGURATION_TAB_HIDDEN = true
    let IS_CENTRALIZE_TAB_HIDDEN = true
    let IS_DASHBOARDCONFIG_TAB_HIDDEN = true
    let IS_QUALITYCONTROL_TAB_HIDDEN = true
    let IS_SEGMENTED_DASHBOARD_TAB_HIDDEN = true

    const checkViewOperation = (menuName) => {
        const menu = menusAccess.find((item) => item.Menuname === menuName);
        return menu ? menu.ViewOperation : false;
    };

    if (getMenusAccess != null && menusAccess != undefined) {

        IS_DASHBOARD_TAB_HIDDEN = !checkViewOperation("Home Page");
        IS_ALERTS_TAB_HIDDEN = !checkViewOperation(AlertsModule);
        IS_CAMERAS_TAB_HIDDEN = !checkViewOperation("Cameras");
        IS_HEALTH_MONITORING_TAB_HIDDEN = !checkViewOperation("Health Monitoring");
        IS_PANELCONTROL_TAB_HIDDEN = !checkViewOperation("Panel Control");
        IS_REPORTS_TAB_HIDDEN = !checkViewOperation("Reports");
        IS_CUSTOM_REPORTS_TAB_HIDDEN = !checkViewOperation("Custom Reports");
        IS_CONFIGURATION_TAB_HIDDEN = !checkViewOperation("Configuration Tool");
        IS_CENTRALIZE_TAB_HIDDEN = !checkViewOperation("Video Backup");
        IS_QUALITYCONTROL_TAB_HIDDEN = !checkViewOperation("Quality Control");
        IS_SEGMENTED_DASHBOARD_TAB_HIDDEN = !checkViewOperation("Segmented Dashboard")
        // IS_DASHBOARD_TAB_HIDDEN = !menusAccess[0]?.ViewOperation == true    
        // IS_ALERTS_TAB_HIDDEN = !menusAccess[1]?.ViewOperation == true
        // IS_CAMERAS_TAB_HIDDEN = !menusAccess[2]?.ViewOperation == true
        // IS_HEALTH_MONITORING_TAB_HIDDEN = !menusAccess[3]?.ViewOperation == true
        // IS_PANELCONTROL_TAB_HIDDEN = !menusAccess[4]?.ViewOperation == true
        // IS_REPORTS_TAB_HIDDEN = !menusAccess[5]?.ViewOperation == true
        // IS_CUSTOM_REPORTS_TAB_HIDDEN = !menusAccess[6]?.ViewOperation == true
        // IS_CONFIGURATION_TAB_HIDDEN = !menusAccess[7]?.ViewOperation == true
        // IS_CENTRALIZE_TAB_HIDDEN = !menusAccess[8]?.ViewOperation == false
    }

    const location = useLocation()
    let history = useHistory()
    //useState Start Block
    const [displayModal, setDisplayModal] = useState(false);
    const [alertTab] = useState(CheckForPrivilege("ALERT"))
    const [camera] = useState(CheckForPrivilege("CAMERALIST_VIEW"))
    const [menuDataList, setMenuDataList] = useState(null)
    const [dynamicMenuDataList, setDynamicMenuDataList] = useState([]);
    //useState End Block

    const { collapsed, setCollapsed } = useContext(DrawerContext);
    const { isNotificationAlertIdClicked, setIsNotificationAlertIdClicked } = useContext(ConversationStateContext)
    const { isDarkTheme } = useContext(ThemeContext)



    //useEffect Start Block
    useEffect(() => {
        const currentPathname = location.pathname;
        if (location.pathname === DASHBOARD || location.pathname === HOMEPAGE || location.pathname === DASHBOARDCONFIG || location.pathname === DASHBOARD1 || location.pathname === DASHBOARD2) {
            //setSelectedTab('dashboard')
            setSelectedSubMenu(location.pathname.replace("/", ""))
            setSelectedTab('dashboard')
            getMenuMasterList()
            // if (CLOUD_STREAMING == '0') {
            //     runRovarUtilUrl("rovarrutil://")
            // }
        } else if (location.pathname === MYALERTS || location.pathname === ALLALERTS) {
            setSelectedSubMenu(location.pathname.replace("/", ""))
            setSelectedTab('alerts')
            getMenuMasterList()
        } else if (location.pathname.includes("alertdetails") || location.pathname.includes("chatflow") || location.pathname.includes("alertreport")) {
            setSelectedTab('alerts')
            if (location.pathname.includes("alertreport")) {
                setSelectedSubMenu('myalerts')
            } else if (location.pathname.includes("chatflow")) {
                setSelectedSubMenu('allalerts')
            }
        }
        else if (location.pathname === CAMERAS || location.pathname === CAMERA_SINGLE_PLAYBACK) {
            setSelectedTab('camera')
            getMenuMasterList()
            // if (CLOUD_STREAMING == '0') {
            //          runRovarUtilUrl("rovarrutil://")
            //      }
        } else if (location.pathname === PANELCONTROL) {
            setSelectedTab('Panel Control')

        } else if (location.pathname === REPORT_INDEX || location.pathname === REPORT_VIEW) {
            setSelectedTab('Common Report')

        } else if (location.pathname === REPORTS || location.pathname === EVENTACTIVITYREPORT || location.pathname === PANELACTIVITY || location.pathname === OPERATORALERTREPORT || location.pathname === CUSTOMERACTIVITY || location.pathname === CCTVACTIVITY || location.pathname === CUSTOMERSITEACTIVITY || location.pathname === AVAILABLERECORDINGREPORT || location.pathname === DeviceInstallationReport || location.pathname === DeviceStageReport) {
            setSelectedSubMenu(location.pathname.replace("/", ""))
            setSelectedTab('reports')
            getMenuMasterList()
        } else if (location.pathname === DAILYHEALTHCHECKREPORT || location.pathname === PANELUPDOWNREPORT || location.pathname === ATMSITEREPORT || location.pathname === SAMPLEREPORT) {
            setSelectedSubMenu(location.pathname.replace("/", ""))
            setSelectedTab('customreports')
            getMenuMasterList()
        }
        else if (location.pathname === CONFIGURATION) {
            // setSelectedTab('reports')
        } else if (location.pathname == ROOT) {
            history.push(DASHBOARD1)
            getMenuMasterList()
        } else if (location.pathname === HEALTHMONITORING) {
            setSelectedTab('healthmonitoring')
            getMenuMasterList()
        }
        else if (location.pathname === CENTRALIZERECORDING) {

            setSelectedTab('Centralize Recording')
        }
        else if (location.pathname === currentPathname) {
            getMenuMasterList()
            setSelectedTab(currentPathname)
        }
        else if (location.pathname === DASHBOARDCHARTS) {
            setSelectedTab('dashboardchart')
            getMenuMasterList()
        }
     else if (location.pathname === QUALITYCONTROL) {
            setSelectedTab(QUALITYCONTROL)
        }else if(location.pathname === DASHBOARDCONFIG){
            setSelectedTab(DASHBOARDCONFIG)
        }

    }, [location.pathname])

    useEffect(() => {
        if (isNotificationAlertIdClicked) {
            setSelectedTab('alerts')
        }
        return () => setIsNotificationAlertIdClicked(false)
    }, [isNotificationAlertIdClicked])


    useEffect(() => {
        GetDynamicSidebarMenu().then((resp)=>{
            if (resp.Status == "success"){
                if(resp.Data != null){
                    setDynamicMenuDataList(resp.Data)
                }
            }else {
                setDynamicMenuDataList([])
            }
        }).catch(err => console.log(err))
    }, []);

    //useEffect Block End

    const getMenuMasterList = () => {
        try {
            // MenuMasterListAPI().then((resp) => {
            //     if (resp !== undefined) {
            //         if (resp.Status == "success") {
            //             setMenuDataList(resp.Data)
            //         } else {
            //             setMenuDataList(null)
            //         }
            //     }
            // })
        } catch (error) {
            console.log(error)
        }
    }
    // getMenuMasterList()
    const runRovarUtilUrl = (url) => {
        const requestOptions = { method: "GET" };
        // Linking.canOpenURL(url).then(supported => {
        //     if (!supported) {
        //       console.log('Can\'t handle url: ' + url);
        //     } else {
        //       return Linking.openURL(url);
        //     }
        //   }).catch(err => console.error('An error occurred', err))        

        window.open(url, "_blank", "noreferrer")

        fetch('http://localhost:3000/list', requestOptions)
            .then((resp) => { return resp.json(); })
            .then(function (data) {

                return data;
            }).catch(function (error) {
                setDisplayModal(true);
            });
    }

    return (
        <>
            <div className={collapsed ? '' : 'sidebar-minimized'}>
                <div className="sidebar left updatedSidebar">
                    <nav className="sidebar-nav">
                        <div className="menu-list">
                            <ul id="menu-content" className="navList borderLineList" >

                                {
                                    <li 
                                    // style={{ display: IS_DASHBOARDCONFIG_TAB_HIDDEN ? 'none' : 'block' }}
                                    onClick={() => {
                                        setSelectedTab('dashboard')
                                        setSelectedSubMenu("consolidated")
                                        history.push(DASHBOARD1)
                                    }}
                                        className={selectedTab == "dashboard" ? "nav-item nav-dropdown open" : "nav-item nav-dropdown"}>
                                        <a className='nav-link nav-dropdown-toggle'>
                                            {
                                                !isDarkTheme ?
                                                    <>
                                                        <img src={selectedTab == "dashboard" ? dashboard : dashboard} alt="Logo" height={17} width={17} />
                                                        <span className={`pl-3 ${selectedTab == "dashboard" ? "nav-label" : "nav-label"}`}>Dashboard</span>
                                                    </>
                                                    :
                                                    <>
                                                        <img className='onHoverImage' src={selectedTab == "dashboard" ? dashboard : DashboardUnselected} alt="Logo" height={17} width={17} />
                                                        <img src={dashboard} className='onHoverActiveImage' height={17} width={17} />
                                                        <span className={`pl-3 ${selectedTab == "dashboard" ? "nav-label" : "nav-label"}`}>Dashboard</span>
                                                    </>
                                            }
                                        </a>
                                    </li>
                                }
                                {
                                    <div
                                        style={{ display: selectedTab == "dashboard" ? "block" : "none" }}

                                        className={`collapse-menu ${selectedTab != "dashboard" ? "hide" : ""}`}>
                                        <ul className={`nav-dropdown-items`} id="products">
                                            <li className={`${selectedSubMenu == "consolidated" ? "active-sub-menu" : ""}`} onClick={() => {
                                                setSelectedSubMenu("consolidated")
                                                setSelectedTab("dashboard")
                                                history.push(DASHBOARD1)
                                            }}>
                                                <span className="nav-link1">Consolidated</span>
                                                {/* <span><Link className="nav-link1" to={PANELACTIVITY}>Event Report</Link></span> */}
                                            </li>
                                            {
                                               !IS_SEGMENTED_DASHBOARD_TAB_HIDDEN 
                                               ?
                                            <li 
                                            className={`${selectedSubMenu == "segmented" ? "active-sub-menu active" : ""}`} onClick={() => {
                                                setSelectedSubMenu("segmented")
                                                setSelectedTab("dashboard")
                                                history.push(DASHBOARD2)
                                            }}>
                                                <span className="nav-link1">Segmented</span>
                                                
                                            </li>
                                            :
                                            null
                                            }
                                           
                                        </ul>
                                    </div>
                                }

                                <li
                                    style={{ display: IS_DASHBOARD_TAB_HIDDEN ? 'none' : 'none' }}
                                    onClick={() => {
                                        setSelectedTab('dashboard')
                                        history.push(HOMEPAGE)
                                    }}
                                    className={selectedTab == "dashboard" ? "highlight nav-item singleItem" : "nav-item singleItem"}>
                                    <a className='nav-link'>
                                        {
                                            !isDarkTheme ?
                                                <>
                                                    <img src={selectedTab == "dashboard" ? dashboard : dashboard} alt="Logo" height={17} width={17} />
                                                    <span className={`pl-3 ${selectedTab == "dashboard" ? "nav-label" : "nav-label"}`}>Home Page</span>
                                                </>
                                                :
                                                <>
                                                    <img className='onHoverImage' src={selectedTab == "dashboard" ? dashboard : DashboardUnselected} alt="Logo" height={17} width={17} />
                                                    <img src={dashboard} className='onHoverActiveImage' height={17} width={17} />
                                                    <span className={`pl-3 ${selectedTab == "dashboard" ? "nav-label" : "nav-label"}`}>Home Page</span>
                                                </>
                                        }
                                    </a>
                                </li>

                                {alertTab &&
                                    <li
                                        style={{ display: IS_ALERTS_TAB_HIDDEN ? 'none' : 'block' }}
                                        onClick={() => {
                                            setSelectedTab('alerts');
                                            history.push('/allalerts')
                                        }}
                                        className={selectedTab == "alerts" ? "highlight nav-item singleItem" : "nav-item singleItem"}
                                    /*  className={selectedTab == "alerts" ? "nav-item nav-dropdown open" : "nav-item nav-dropdown"} */
                                    >
                                        <a className="nav-link nav-dropdown-toggle">
                                            {
                                                !isDarkTheme ?
                                                    <>
                                                        <img src={selectedTab == "alerts" ? alertSelected : alertSelected} alt="Logo" height={17} width={17} />
                                                        <span className={`pl-3 ${selectedTab == "alerts" ? "nav-label" : "nav-label"}`}>Alerts</span>
                                                    </> :
                                                    <>
                                                        <img className='onHoverImage' src={selectedTab == "alerts" ? alertSelected : alertUnselected} alt="Logo" height={17} width={17} />
                                                        <img src={alertSelected} className='onHoverActiveImage' height={17} width={17} />
                                                        <span className={`pl-3 ${selectedTab == "alerts" ? "nav-label" : "nav-label"}`}>Alerts</span>
                                                    </>
                                            }
                                        </a>
                                    </li>
                                }
                                {
                                    // <div
                                    //     style={{ display: selectedTab == "alerts" ? "block" : "none" }}
                                    //     className={`collapse-menu ${selectedTab != "alerts" ? "hide" : ""}`}>
                                    //     <ul className={`nav-dropdown-items`} id="products">

                                    //         {/* <li className={`${selectedSubMenu == 'allalerts' ? 'active-sub-menu active' : ''}`} onClick={() => {
                                    //             setSelectedSubMenu('allalerts')
                                    //             setSelectedTab('alerts')
                                    //         }}>
                                    //             <Link className="nav-link1" to={ALLALERTS}><span>All Alerts</span></Link>

                                    //         </li> */}
                                    //         {/* <li className={`${selectedSubMenu == 'myalerts' ? 'active-sub-menu' : ''}`} onClick={() => {
                                    //             setSelectedSubMenu('myalerts')
                                    //             setSelectedTab('alerts')
                                    //         }}>
                                    //             <Link className="nav-link1" to={MYALERTS}><span>Closed Alerts</span></Link>
                                    //         </li> */}
                                    //     </ul>
                                    // </div>
                                }

                                {camera &&
                                    <li
                                        style={{ display: IS_CAMERAS_TAB_HIDDEN ? 'none' : 'block' }}
                                        onClick={() => {
                                            setSelectedTab('camera')
                                            history.push('/cameras/true')
                                            // if (CLOUD_STREAMING == '0') {
                                            //     runRovarUtilUrl("rovarrutil://")
                                            // }
                                            // console.log("Location",location)
                                        }
                                        }
                                        className={selectedTab == "camera" ? "highlight nav-item singleItem" : "nav-item singleItem"}>
                                        <a className='nav-link'>
                                            {
                                                !isDarkTheme ?
                                                    <>
                                                        <img src={selectedTab == "camera" ? cameraSelected : cameraSelected} alt="Logo" height={17} width={17} />
                                                        <span className={`pl-3 ${selectedTab == "camera" ? "nav-label" : "nav-label"}`}>Cameras</span>
                                                    </>
                                                    :
                                                    <>
                                                        <img className='onHoverImage' src={selectedTab == "camera" ? cameraSelected : cameraUnselected} alt="Logo" height={17} width={17} />
                                                        <img src={cameraSelected} className='onHoverActiveImage' height={17} width={17} />
                                                        <span className={`pl-3 ${selectedTab == "camera" ? "nav-label" : "nav-label"}`}>Cameras</span>
                                                    </>
                                            }
                                        </a>
                                    </li>
                                }

                                <li
                                    style={{ display: IS_HEALTH_MONITORING_TAB_HIDDEN ? 'none' : 'block' }}
                                    onClick={() => {
                                        setSelectedTab('healthmonitoring')
                                        history.push('/healthmonitoring')
                                    }}
                                    className={selectedTab == "healthmonitoring" ? "highlight nav-item singleItem" : "nav-item singleItem"}>
                                    <a className='nav-link'>
                                        {
                                            !isDarkTheme ?
                                                <>
                                                    <img src={selectedTab == "healthmonitoring" ? HMSelected : HMSelected} alt="Logo" height={17} width={17} />
                                                    <span className={`pl-3 ${selectedTab == "healthmonitoring" ? "nav-label" : "nav-label"}`}>Health Monitoring</span>
                                                </>
                                                :
                                                <>
                                                    <img className='onHoverImage' src={selectedTab == "healthmonitoring" ? HMSelected : HMUnSelected} alt="Logo" height={17} width={17} />
                                                    <img src={HMSelected} className='onHoverActiveImage' height={17} width={17} />
                                                    <span className={`pl-3 ${selectedTab == "healthmonitoring" ? "nav-label" : "nav-label"}`}>Health Monitoring</span>
                                                </>
                                        }
                                    </a>
                                </li>

                                {
                                    //isSuperUser?
                                    <li
                                        style={{ display: IS_PANELCONTROL_TAB_HIDDEN ? 'none' : 'block' }}
                                        onClick={() => {
                                            setSelectedTab('Panel Control');
                                            history.push(PANELCONTROL)
                                        }}
                                        className={` ${selectedTab == "Panel Control" ? "nav-item nav-dropdown open noDrop navPage" : 'nav-item nav-dropdown navPage'}`}>
                                        <a className='nav-link'>
                                            {
                                                !isDarkTheme ?
                                                    <>
                                                        <img src={selectedTab == "Panel Control" ? PanelControlWhite : PanelControlWhite} alt="Logo" height={18} />
                                                        <span className={`pl-3 ${selectedTab == "Panel Control" ? "nav-label" : "nav-label"}`}>Panel Control</span>
                                                    </>
                                                    :
                                                    <>
                                                        <img className='onHoverImage' src={selectedTab == "Panel Control" ? PanelControlWhite : PanelControl} alt="Logo" height={18} />
                                                        <img src={PanelControlWhite} className='onHoverActiveImage' height={18} />
                                                        <span className={`pl-3 ${selectedTab == "Panel Control" ? "nav-label" : "nav-label"}`}>Panel Control</span>
                                                    </>
                                            }
                                        </a>
                                    </li>
                                    //: null
                                }

                                {
                                    <li
                                        style={{ display: IS_REPORTS_TAB_HIDDEN ? 'none' : 'block' }}
                                        onClick={() => {
                                            setSelectedTab('Common Report');
                                            history.push(REPORT_INDEX)
                                        }}
                                        className={` ${selectedTab == "Common Report" ? "nav-item nav-dropdown open noDrop navPage" : 'nav-item nav-dropdown navPage'}`}>
                                        <a className='nav-link'>
                                            {
                                                !isDarkTheme ?
                                                    <>
                                                        <img src={selectedTab == "Common Report" ? reportSelected : reportSelected} alt="Logo" height={18} />
                                                        <span className={`pl-3 ${selectedTab == "Common Report" ? "nav-label" : "nav-label"}`}>Reports</span>
                                                    </>
                                                    :
                                                    <>
                                                        <img className='onHoverImage' src={selectedTab == "Common Report" ? reportSelected : reportUnselected} alt="Logo" height={18} />
                                                        <img src={reportSelected} className='onHoverActiveImage' height={18} />
                                                        <span className={`pl-3 ${selectedTab == "Common Report" ? "nav-label" : "nav-label"}`}>Reports</span>
                                                    </>
                                            }
                                        </a>
                                    </li>
                                }

                                <li
                                    style={{ display: IS_REPORTS_TAB_HIDDEN ? 'none' : 'none' }}
                                    onClick={() => {
                                        setSelectedTab('reports')
                                        setSelectedSubMenu("panelactivity")
                                        history.push('/panelactivity')
                                    }}
                                    className={selectedTab == "reports" ? "nav-item nav-dropdown open" : "nav-item nav-dropdown"}>
                                    <a className='nav-link nav-dropdown-toggle'>
                                        {
                                            !isDarkTheme ?
                                                <>
                                                    <img src={selectedTab == "reports" ? reportSelected : reportSelected} alt="Logo" height={17} width={17} />
                                                    <span className={`pl-3 ${selectedTab == "reports" ? "nav-label" : "nav-label"}`}>Reports</span>
                                                </>
                                                :
                                                <>
                                                    <img className='onHoverImage' src={selectedTab == "reports" ? reportSelected : reportUnselected} alt="Logo" height={17} width={17} />
                                                    <img src={reportSelected} className='onHoverActiveImage' height={17} width={17} />
                                                    <span className={`pl-3 ${selectedTab == "reports" ? "nav-label" : "nav-label"}`}>Reports</span>
                                                </>
                                        }
                                    </a>
                                </li>
 
                                {
                                    <div
                                        style={{ display: selectedTab == "reports" ? "block" : "none" }}
                                        className={`collapse-menu ${selectedTab != "reports" ? "hide" : ""}`}>
                                        <ul className={`nav-dropdown-items`} id="products">
                                            <li className={`${selectedSubMenu == "panelactivity" ? "active-sub-menu" : ""}`} onClick={() => {
                                                setSelectedSubMenu("panelactivity")
                                                setSelectedTab("reports")
                                                history.push(PANELACTIVITY)
                                            }}>
                                                <span className="nav-link1">Event Report</span>
                                                {/* <span><Link className="nav-link1" to={PANELACTIVITY}>Event Report</Link></span> */}
                                            </li>

                                            <li className={`${selectedSubMenu == "alertactivity" ? "active-sub-menu active" : ""}`} onClick={() => {
                                                setSelectedSubMenu("alertactivity")
                                                setSelectedTab("reports")
                                                history.push(REPORTS)
                                            }}>
                                                <span className="nav-link1">Alert Report</span>
                                                {/* <Link className="nav-link1" to={REPORTS}><span>Alert Report</span></Link> */}
                                            </li>

                                            <li className={`${selectedSubMenu == "eventactivity" ? "active-sub-menu" : ""}`} onClick={() => {
                                                setSelectedSubMenu("eventactivity")
                                                setSelectedTab("reports")
                                                history.push(EVENTACTIVITYREPORT)
                                            }}>
                                                <span className="nav-link1">Health Report</span>
                                                {/* <Link className="nav-link1" to={EVENTACTIVITYREPORT}><span>Health Report</span></Link> */}
                                            </li>

                                            <li className={`${selectedSubMenu == "customeractivity" ? "active-sub-menu" : ""}`} onClick={() => {
                                                setSelectedSubMenu("customeractivity")
                                                setSelectedTab("reports")
                                                history.push(CUSTOMERACTIVITY)
                                            }}>
                                                <span className="nav-link1">Customer Alert Count Report</span>
                                                {/* <Link className="nav-link1" to={CUSTOMERACTIVITY}><span>Customer Alert Count Report</span></Link> */}
                                            </li>

                                            <li className={`${selectedSubMenu == "customersiteactivity" ? "active-sub-menu" : ""}`} onClick={() => {
                                                setSelectedSubMenu("customersiteactivity")
                                                setSelectedTab("reports")
                                                history.push(CUSTOMERSITEACTIVITY)
                                            }}>
                                                <span className="nav-link1">Customer Site Alert Count Report</span>
                                                {/* <Link className="nav-link1" to={CUSTOMERSITEACTIVITY}><span>Customer Site Alert Count Report</span></Link> */}
                                            </li>

                                            <li className={`${selectedSubMenu == "operatoractivity" ? "active-sub-menu" : ""}`} onClick={() => {
                                                setSelectedSubMenu("operatoractivity")
                                                setSelectedTab("reports")
                                                history.push(OPERATORALERTREPORT)
                                            }}>
                                                <span className="nav-link1">Operator Alert Report</span>
                                                {/* <Link className="nav-link1" to={OPERATORALERTREPORT}><span>Operator Alert Report</span></Link> */}
                                            </li>

                                            {/* <li className={`${selectedSubMenu == "dailyhealthcheckactivity" ? "active-sub-menu" : ""}`} onClick={() => {
                                                setSelectedSubMenu("dailyhealthcheckactivity")
                                                setSelectedTab("reports")
                                            }}>
                                                <Link className="nav-link1" to={DAILYHEALTHCHECKREPORT}><span>Daily Report</span></Link>
                                            </li>

                                            <li className={`${selectedSubMenu == "panelupdownactivity" ? "active-sub-menu" : ""}`} onClick={() => {
                                                setSelectedSubMenu("panelupdownactivity")
                                                setSelectedTab("reports")
                                            }}>
                                                <Link className="nav-link1" to={PANELUPDOWNREPORT}><span>Panel Up Down Report</span></Link>
                                            </li> 

                                            <li className={`${selectedSubMenu == "atmsiteactivity" ? "active-sub-menu" : ""}`} onClick={() => {
                                                setSelectedSubMenu("atmsiteactivity")
                                                setSelectedTab("reports")
                                            }}>
                                                <Link className="nav-link1" to={ATMSITEREPORT}><span>ATM Report</span></Link>
                                            </li>  */}
                                            {/* <li className={`${selectedSubMenu == "sampleactivity" ? "active-sub-menu" : ""}`} onClick={() => {
                                                setSelectedSubMenu("sampleactivity")
                                                setSelectedTab("reports")
                                            }}>
                                                <Link className="nav-link1" to={SAMPLEREPORT}><span>ATM Motion Report</span></Link>
                                            </li>  */}

                                            <li className={`${selectedSubMenu == "availblerecordingactivity" ? "active-sub-menu" : ""}`} onClick={() => {
                                                setSelectedSubMenu("availblerecordingactivity")
                                                setSelectedTab("reports")
                                                history.push(AVAILABLERECORDINGREPORT)
                                            }}>
                                                <span className="nav-link1">Available Recording Report</span>
                                                {/* <Link className="nav-link1" to={AVAILABLERECORDINGREPORT}><span>Available Recording Report</span></Link> */}
                                            </li>

                                            <li className={`${selectedSubMenu == "DeviceInstallationReport" ? "active-sub-menu" : ""}`} onClick={() => {
                                                setSelectedSubMenu("DeviceInstallationReport")
                                                setSelectedTab("reports")
                                                history.push(DeviceInstallationReport)
                                            }}>
                                                <span className="nav-link1">Device Installation Report</span>
                                            </li>

                                            <li className={`${selectedSubMenu == "DeviceStageReport" ? "active-sub-menu" : ""}`} onClick={() => {
                                                setSelectedSubMenu("DeviceStageReport")
                                                setSelectedTab("reports")
                                                history.push(DeviceStageReport)
                                            }}>
                                                <span className="nav-link1">Device Stage Report</span>
                                            </li>
                                        </ul>
                                    </div>
                                }

                                <li
                                    style={{ display: IS_CUSTOM_REPORTS_TAB_HIDDEN ? 'none' : 'block' }}
                                    onClick={() => {
                                        setSelectedTab('customreports')
                                        setSelectedSubMenu("dailyhealthcheckactivity")
                                        history.push(DAILYHEALTHCHECKREPORT)
                                    }}
                                    className={selectedTab == "customreports" ? "nav-item nav-dropdown open" : "nav-item nav-dropdown"}>
                                    <a className='nav-link nav-dropdown-toggle'>
                                        {
                                            !isDarkTheme ?
                                                <>
                                                    <img src={selectedTab == "customreports" ? reportSelected : reportSelected} alt="Logo" height={17} width={17} />
                                                    <span className={`pl-3 ${selectedTab == "customreports" ? "nav-label" : "nav-label"}`}>Custom Reports</span>
                                                </>
                                                :
                                                <>
                                                    <img className='onHoverImage' src={selectedTab == "customreports" ? reportSelected : reportUnselected} alt="Logo" height={17} width={17} />
                                                    <img src={reportSelected} className='onHoverActiveImage' height={17} width={17} />
                                                    <span className={`pl-3 ${selectedTab == "customreports" ? "nav-label" : "nav-label"}`}>Custom Reports</span>
                                                </>
                                        }
                                    </a>
                                </li>

                                {
                                    !IS_CUSTOM_REPORTS_TAB_HIDDEN
                                        ?
                                        <div
                                            style={{ display: selectedTab == "customreports" ? "block" : "none" }}
                                            className={`collapse-menu ${selectedTab != "customreports" ? "hide" : ""}`}>
                                            <ul className={`nav-dropdown-items`} id="products">

                                                {
                                                    !IS_DAILY_REPORTS_TAB_HIDDEN
                                                        ?
                                                        <li className={`${selectedSubMenu == "dailyhealthcheckactivity" ? "active-sub-menu" : ""}`} onClick={() => {
                                                            setSelectedSubMenu("dailyhealthcheckactivity")
                                                            setSelectedTab("customreports")
                                                            history.push(DAILYHEALTHCHECKREPORT)
                                                        }}>
                                                            <span className="nav-link1">Daily Report</span>
                                                            {/* <Link className="nav-link1" to={DAILYHEALTHCHECKREPORT}><span>Daily Report</span></Link> */}
                                                        </li>
                                                        : null
                                                }
                                                {
                                                    !IS_PANEL_UP_DOWN_REPORTS_TAB_HIDDEN
                                                        ?
                                                        <li className={`${selectedSubMenu == "panelupdownactivity" ? "active-sub-menu" : ""}`} onClick={() => {
                                                            setSelectedSubMenu("panelupdownactivity")
                                                            setSelectedTab("customreports")
                                                            history.push(PANELUPDOWNREPORT)
                                                        }}>
                                                            <span className="nav-link1">Panel Up Down Report</span>
                                                            {/* <Link className="nav-link1" to={PANELUPDOWNREPORT}><span>Panel Up Down Report</span></Link> */}
                                                        </li>

                                                        : null
                                                }
                                                {
                                                    !IS_ATM_REPORTS_TAB_HIDDEN
                                                        ?
                                                        <li className={`${selectedSubMenu == "atmsiteactivity" ? "active-sub-menu" : ""}`} onClick={() => {
                                                            setSelectedSubMenu("atmsiteactivity")
                                                            setSelectedTab("customreports")
                                                            history.push(ATMSITEREPORT)
                                                        }}>
                                                            <span className="nav-link1">ATM Report</span>
                                                            {/* <Link className="nav-link1" to={ATMSITEREPORT}><span>ATM Report</span></Link> */}
                                                        </li>
                                                        : null
                                                }

                                                {/* <li className={`${selectedSubMenu == "availblerecordingactivity" ? "active-sub-menu" : ""}`} onClick={() => {
                                                setSelectedSubMenu("availblerecordingactivity")
                                                setSelectedTab("customreports")
                                            }}>
                                                <Link className="nav-link1" to={AVAILABLERECORDINGREPORT}><span>Available Recording Report</span></Link>
                                            </li>  */}
                                            </ul>
                                        </div>
                                        : null
                                }

                                {
                                    <li 
                                        style={{ display: !IS_CENTRALIZE_TAB_HIDDEN ? 'block' : 'none' }}
                                        onClick={() => {
                                            setSelectedTab('Centralize Recording')
                                            history.push(CENTRALIZERECORDING)
                                        }}
                                            className={selectedTab == "Centralize Recording" ? "highlight nav-item singleItem navPage" : "nav-item singleItem navPage"}>
                                            <a className='nav-link'>
                                                {
                                                    !isDarkTheme ?
                                                        <>
                                                            <img src={selectedTab == "Centralize Recording" ? CentralizeRecordingSelected : CentralizeRecordingSelected} alt="Logo" height={17} width={17} />
                                                            <span className={`pl-3 ${selectedTab == "Centralize Recording" ? "nav-label" : "nav-label"}`}>Video Backup</span>
                                                        </>
                                                        :
                                                        <>
                                                            <img className='onHoverImage' src={selectedTab == "Centralize Recording" ? CentralizeRecordingSelected : CentralizeRecording} alt="Logo" height={17} width={17} />
                                                            <img src={CentralizeRecordingSelected} className='onHoverActiveImage' height={17} width={17} />
                                                            <span className={`pl-3 ${selectedTab == "Centralize Recording" ? "nav-label" : "nav-label"}`}>Video Backup</span>
                                                        </>
                                                }
                                            </a>
                                        </li>
                                }

                                {/* {
                                    <li 
                                        // style={{ display: !IS_CENTRALIZE_TAB_HIDDEN ? 'block' : 'none' }}
                                        onClick={() => {
                                            setSelectedTab('Import')
                                            history.push(CENTRALIZERECORDING)
                                        }}
                                            className={selectedTab == "Import" ? "highlight nav-item singleItem navPage" : "nav-item singleItem navPage"}>
                                            <a className='nav-link'>
                                                {
                                                    !isDarkTheme ?
                                                        <>
                                                            <img src={selectedTab == "Import" ? CentralizeRecordingSelected : CentralizeRecordingSelected} alt="Logo" height={17} width={17} />
                                                            <span className={`pl-3 ${selectedTab == "Import" ? "nav-label" : "nav-label"}`}>Import</span>
                                                        </>
                                                        :
                                                        <>
                                                            <img className='onHoverImage' src={selectedTab == "Import" ? CentralizeRecordingSelected : CentralizeRecording} alt="Logo" height={17} width={17} />
                                                            <img src={CentralizeRecordingSelected} className='onHoverActiveImage' height={17} width={17} />
                                                            <span className={`pl-3 ${selectedTab == "Import" ? "nav-label" : "nav-label"}`}>Import</span>
                                                        </>
                                                }
                                            </a>
                                    </li>
                                }
                                {
                                    <li 
                                        // style={{ display: !IS_CENTRALIZE_TAB_HIDDEN ? 'block' : 'none' }}
                                        onClick={() => {
                                            setSelectedTab('Export')
                                            history.push(CENTRALIZERECORDING)
                                        }}
                                            className={selectedTab == "Export" ? "highlight nav-item singleItem navPage" : "nav-item singleItem navPage"}>
                                            <a className='nav-link'>
                                                {
                                                    !isDarkTheme ?
                                                        <>
                                                            <img src={selectedTab == "Export" ? CentralizeRecordingSelected : CentralizeRecordingSelected} alt="Logo" height={17} width={17} />
                                                            <span className={`pl-3 ${selectedTab == "Export" ? "nav-label" : "nav-label"}`}>Export</span>
                                                        </>
                                                        :
                                                        <>
                                                            <img className='onHoverImage' src={selectedTab == "Export" ? CentralizeRecordingSelected : CentralizeRecording} alt="Logo" height={17} width={17} />
                                                            <img src={CentralizeRecordingSelected} className='onHoverActiveImage' height={17} width={17} />
                                                            <span className={`pl-3 ${selectedTab == "Export" ? "nav-label" : "nav-label"}`}>Export</span>
                                                        </>
                                                }
                                            </a>
                                    </li>
                                } */}

                                {
                                    <li
                                        style={{ display: IS_QUALITYCONTROL_TAB_HIDDEN ? 'none' : 'block' }}
                                        onClick={() => {
                                            setSelectedTab(QUALITYCONTROL)
                                            history.push(QUALITYCONTROL)
                                        }}
                                        className={selectedTab == QUALITYCONTROL ? "highlight nav-item singleItem navPage" : "nav-item singleItem navPage"}>
                                        <a className='nav-link'>
                                            {
                                                !isDarkTheme ?
                                                    <>
                                                        <img src={selectedTab == QUALITYCONTROL ? QualityControlWhite : QualityControlWhite} alt="Logo" height={20} width={20} />
                                                        <span className={`pl-3 ${selectedTab == QUALITYCONTROL ? "nav-label" : "nav-label"}`}>Quality Control</span>
                                                    </>
                                                    :
                                                    <>
                                                        <img className='onHoverImage' src={selectedTab == QUALITYCONTROL ? QualityControlWhite : QualityControl} alt="Logo" height={20} width={20} />
                                                        <img src={QualityControlWhite} className='onHoverActiveImage' height={20} width={20} />
                                                        <span className={`pl-3 ${selectedTab == QUALITYCONTROL ? "nav-label" : "nav-label"}`}>Quality Control</span>
                                                    </>
                                            }
                                        </a>
                                    </li>
                                }
                                

                                {
                                    //isSuperUser? 
                                    <li
                                        style={{ display: IS_CONFIGURATION_TAB_HIDDEN ? 'none' : 'block' }}
                                        onClick={() => {
                                            // debugger
                                            // history.push('/configuration')
                                            history.push('/configuration/customers')
                                        }}
                                        className={selectedTab == "sidebarActive" ? "highlight nav-item singleItem navPage" : "nav-item singleItem navPage"}>
                                        <a className='nav-link'>
                                            {
                                                !isDarkTheme ?
                                                    <>
                                                        <img src={selectedTab == "" ? configSelectedWhite : configSelectedWhite} alt="Logo" height={17} width={17} />
                                                        <span className={`pl-3 ${selectedTab == "" ? "nav-label" : "nav-label"}`}>Configuration Tool</span>
                                                    </>
                                                    :
                                                    <>
                                                        <img className='onHoverImage' src={selectedTab == "" ? configSelectedWhite : configSelected} alt="Logo" height={17} width={17} />
                                                        <img src={configSelectedWhite} className='onHoverActiveImage' height={17} width={17} />
                                                        <span className={`pl-3 ${selectedTab == "" ? "nav-label" : "nav-label"}`}>Configuration Tool</span>
                                                    </>
                                            }
                                        </a>
                                    </li>
                                    // : null
                                }

                                {
                                    menuDataList &&
                                    (menuDataList.length > 0 ?
                                        menuDataList.map((menuItem) => {
                                            return (
                                                <li
                                                    onClick={() => {
                                                        history.push(`/page/${menuItem.MenuId}`)
                                                        sessionStorage.setItem("customURL", menuItem.Menuurl)

                                                    }}
                                                    key={menuItem.MenuId}
                                                    className={selectedTab == `/page/${menuItem.MenuId}` ? "nav-item nav-dropdown navPage noDrop open" : "nav-item nav-dropdown navPage"}

                                                >
                                                    <a className="nav-link"  // href={menuItem.Menuurl}
                                                    >
                                                        <img
                                                            src={selectedTab == `/page/${menuItem.MenuId}` ? `/static/media/${menuItem.Iconname.split(".")[0] + "_selected." + menuItem.Iconname.split(".")[1]}` : `/static/media/${menuItem.Iconname}`}
                                                            alt="Logo" height={17} width={17}
                                                        />
                                                        <span className={`pl-3 ${selectedTab == "" ? "nav-label" : "nav-label"}`}>{menuItem.MenuName}</span>
                                                    </a>
                                                </li>
                                            )
                                        }
                                        )
                                        :
                                        "")
                                }

                                <li
                                    style={{ display: IS_DASHBOARD_CHART_TAB_HIDDEN ? 'none' : 'none' }}
                                    onClick={() => {
                                        setSelectedTab('dashboardchart');
                                        history.push('/dashboardchart')
                                    }}
                                    className={selectedTab == "dashboardchart" ? "highlight nav-item singleItem" : "nav-item singleItem"}
                                /*  className={selectedTab == "alerts" ? "nav-item nav-dropdown open" : "nav-item nav-dropdown"} */
                                >
                                    <a className="nav-link nav-dropdown-toggle">
                                        {
                                            !isDarkTheme ?
                                                <>
                                                    <img src={selectedTab == "dashboardchart" ? alertSelected : alertSelected} alt="Logo" height={17} width={17} />
                                                    <span className={`pl-3 ${selectedTab == "dashboardchart" ? "nav-label" : "nav-label"}`}>Dashboard Module</span>
                                                </> :
                                                <>
                                                    <img className='onHoverImage' src={selectedTab == "dashboardchart" ? alertSelected : alertUnselected} alt="Logo" height={17} width={17} />
                                                    <img src={alertSelected} className='onHoverActiveImage' height={17} width={17} />
                                                    <span className={`pl-3 ${selectedTab == "dashboardchart" ? "nav-label" : "nav-label"}`}>Dashboard Module</span>
                                                </>
                                        }
                                    </a>
                                </li>
                            </ul>

                            {
                                EXTERNAL_LINK   ? 
                                 <ul className="navList">
                                {dynamicMenuDataList && dynamicMenuDataList.length > 0 &&
                                    dynamicMenuDataList.map((menuItem) => {
                                        const url = /^http?:\/\//.test(menuItem.MenuURL)
                                            ? menuItem.MenuURL : `http://${menuItem.MenuURL}`;
                                            return (
                                                <li key={menuItem.MenuLinkID} className="nav-item">
                                                    <a
                                                        className="nav-link nav-dropdown-toggle"
                                                        style={{ cursor: "pointer" }}
                                                        href={url}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        {
                                                            !isDarkTheme ?
                                                            <>
                                                                <img src={ExternalLinkWhite} alt="Logo" height={17} width={17} />
                                                                <span className={`pl-3 nav-label`}>{menuItem.MenuName}</span>
                                                            </> :
                                                            <>
                                                                <img className='onHoverImage' src={selectedTab == "dashboardchart" ? ExternalLinkWhite : ExternalLink} alt="Logo" height={17} width={17} />
                                                                <img src={ExternalLinkWhite} className='onHoverActiveImage' height={17} width={17} />
                                                                <span className={`pl-3 nav-label`}>{menuItem.MenuName}</span>
                                                            </>
                                                        }
                                                    </a>
                                                </li>
                                            );
                                    })
                                }
                            </ul>
                            : null
                            }
                           
                        </div>
                       

                        <div className='versionTextDiv'>
                            <button className='termsText' onClick={(e) => { history.push(ABOUTTERMS) }}>T&C</button>
                            <p className='maxVersion'>Version: {VERSION}</p>
                            <p className='minVersion'>V- {VERSION}</p>
                        </div>
                    </nav>
                </div>
            </div>

            <Modal
                size='lg'
                show={displayModal}
                onHide={() => setDisplayModal(false)}
                className='downloadUtilityMainclass'
                backdrop="static"
            >
                <Modal.Header closeButton style={{ borderBottom: "none" }}>
                    {/* <Modal.Title>
                    <p className="ModelHeaderName">
                    Download Utility
                    </p>
                </Modal.Title> */}
                    {/* <div className='ModalBodyDiv'>
                <MonitoringHubLogo className="UtilityMHLogo" />
                </div> */}
                </Modal.Header>

                <Modal.Body>
                    <div className='ModalBodyDiv'>
                        <MonitoringHubLogo className="UtilityMHLogo" />
                        <div className='text-center' style={{ marginTop: "60px" }}>
                            <p>
                                UTILITY DOWNLOAD
                            </p>
                            <p className='UtilityText'>
                                To direct stream video, download and install <br />
                                MonitoringHub Utility
                            </p>
                            <a
                                href={CLIENT_COMPONENET_LINK}
                                download>
                                <button
                                    className="DataAccessEdit mt-1"
                                    style={{ width: "450px", height: "45px" }}
                                >
                                    <span className="ViewUpdate ml-1" style={{ fontSize: "0.975rem" }}>Download</span>
                                </button>
                            </a>
                        </div>

                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}
